import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import htmlEscaper$1, { applyNow, htmlEscaper } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"row\">\r\n  <div class=\"column small-12\">\r\n    <div class=\"campaignPropertiesSection\">\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div id=\"apply-now-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":10,"column":38},"end":{"line":10,"column":52}}}))
    + "\"></div>\r\n\r\n\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"show-for-medium-up\">\r\n    <div class=\"row\">\r\n      <div class=\"column text-center small-12\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNow") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,"",((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":5,"column":158}}}))
    + "\r\n      </div>\r\n    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"HELP_CENTER_PHONE_NUMBER") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":21,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n\r\n  <div class=\"row show-for-small-only mt-20\">\r\n    <div class=\"column small-12\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNow") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),null,"",((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"USA_ENABLE") : stack1),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":26,"column":6},"end":{"line":26,"column":156}}}))
    + "\r\n    </div>\r\n  </div>\r\n  <div class=\"row show-for-small-only mt-20\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"HELP_CENTER_PHONE_NUMBER") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":4},"end":{"line":74,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"row contains-phone\">\r\n        <div class=\"column small-12 phone-number-info\" data-font=\"cnx-regular\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"helpPhoneNumber") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"APPLICATION_DISPLAY_APPLY_BY_PHONE_SOURCE_CODE") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":6},"end":{"line":20,"column":13}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"row contains-priority-code\">\r\n        <div class=\"column small-12 priority-code-info\" data-font=\"cnx-regular\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"priorityCodeLine") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"column small-12\">\r\n        <section class=\"accordion-wrapper\" id=\"apply-now-accordion\" data-accordion-type=\"accordion\">\r\n          <div class=\"accordion-tablist\" role=\"application\">\r\n          </div>\r\n          <div class=\"accordion-panels\">\r\n            <div class=\"accordion-panel\" id=\"apply-now-panel1\">\r\n              <div class=\"panel-content\" aria-labelledby=\"apply-now-panel1\" >\r\n                <div class=\"content\">\r\n                  <div class=\"row small-dropdown\">\r\n                    <div class=\"column small-12\">\r\n                      <div class=\"icon feature\">\r\n                        <img src=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"contentRoot") : stack1), depth0)) != null ? stack1 : "")
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"callImage") : stack1), depth0))
    + "\" />\r\n                      </div>\r\n                      <div class=\"feature\">\r\n                        <p class=\"not-ready-text-blue\">\r\n                          <a href=\"tel:"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"HELP_CENTER_PHONE_NUMBER") : stack1), depth0))
    + "\" id=\"click-to-call\">\r\n                            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"callUs") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                          </a>\r\n                        </p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0)) != null ? lookupProperty(stack1,"APPLICATION_DISPLAY_APPLY_BY_PHONE_SOURCE_CODE") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":24},"end":{"line":59,"column":31}}})) != null ? stack1 : "")
    + "                      </div>\r\n                    </div>\r\n                    <div class=\"small-12 column mt-20 feature icon\">\r\n                      <p class=\"not-ready-text-blue feature\" data-font=\"cnx-regular\">\r\n                        "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"connectWithSmall") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":64,"column":24},"end":{"line":64,"column":63}}}))
    + "\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </section>\r\n      </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <p class=\"priority-code-info contains-priority-code\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"priorityCodeLine") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":76,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/apply-now-cc-module",
  "version": "5.0.2",
  "id": "applyNowCcModule",
  "containerID": "creditCardsApplyNowCcModule",
  "moduleName": "credit-cards-apply-now-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "apply-now-cc-module",
  "data": {
    "init": "applyNowCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "requesttype",
    "values": ["C", "BCC"],
    "default": "C",
    "description": "Consumer or Small Business Request Type"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        link,
        json,
        applyNow,
        htmlEscaper
      },
      "partials": {
        "apply-now-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "apply-now-cc-partial": renderTemplate
  },
  "helpers": {
    link,
    json,
    applyNow,
    htmlEscaper
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global sparta spaParams */

/*
 * apply-now-cc-module
 * module_js_id: applyNowCcModuleJS
 *
 * Copyright (c) 2017-12-4
 */

/**
 * @export
 * @class applyNowCcModuleJS
 * @extends {Module}
 */
class applyNowCcModuleJS extends Module {
  /**
   * Creates an instance of applyNowCcModuleJS.
   * @param {object} options - options object
   * @param {object} context - context object
   * @memberof applyNowCcModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.content = JSON.parse(target.querySelector('#apply-now-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['apply-now-cc-partial'];
  }

  /**
   * Initializes the applyNowCcModule
   * @memberof applyNowCcModuleJS
   * @returns {void}
   */
  init() {
    let campaignProperties;
    this.Events.sub('campaignProperties-spartaStore', data => {
      campaignProperties = data.data.data;
      const campaign = this.Store.getData('campaign');
      campaign.ID = creditCardUtility.buildCampaignString(campaign);
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);
      const {
        target
      } = this.settings;
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        content: linkContent,
        site: spaParams.siteParams,
        params: this.params,
        sparta
      }, {
        helpers: {
          htmlEscaper: htmlEscaper$1
        }
      });
      target.querySelector('.campaignPropertiesSection').innerHTML = renderedTemplate;
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });
    });
  }
}
registerModuleClass({
  moduleClass: applyNowCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { applyNowCcModuleJS as default, moduleConfig };
